import { mutatorAction } from 'satcheljs';
export default mutatorAction('tableEnterVirtualSelectAllMode', function tableEnterVirtualSelectAllMode(tableView) {
    tableView.selectAllModeTimeStamp = new Date();
    tableView.isInVirtualSelectAllMode = true;
});
//# sourceMappingURL=tableEnterVirtualSelectAllMode.js.map